/**
 * Combines a series of class names into one class name.
 *
 * @param classNames - Collection of class names to join
 */
export var buildClassNames = function buildClassNames() {
  var fixedClassName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  for (var _len = arguments.length, classNames = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    classNames[_key - 1] = arguments[_key];
  }

  return [fixedClassName].concat(classNames).filter(function (x) {
    return x;
  }).join(' ').trim();
};